<template>
    <div class="search">
        <ais-index :index-name="indexName"
                   :search-store="searchStore"
                   :query-parameters="params"
                   :query="query">


            <div class="large-12">
                <ais-stats style="float: left;">
                    <template slot-scope="{ totalResults, processingTime, query }">
                        There are {{ totalResults }} matching your query: <b>{{ query }}</b>
                    </template>
                </ais-stats>

                <ais-pagination class="pagination" v-on:page-change="onPageChange"></ais-pagination>
                <div style="clear:both"></div>
            </div>
            
            <div style="width: 100%; background-color: #fff;" v-show="searchStore.query.length > 0">
                <ais-menu attribute="type" :sort-by="['name:asc']"></ais-menu>

                <ais-results>
                    <template slot-scope="{ result }">
                        <div class="ais-result">
                            <a :href="baseUrl + result.url">
                                <div style="float: left; width: 19%; min-height: 1px">
                                    <img v-if="result.image" :src="result.image" width="100%">
                                </div>
                                <div style="float: left; width: 79%; margin-left: 2%">
                                    <p style="font-weight: bold">
                                        <ais-highlight :result="result" attribute-name="title"></ais-highlight>
                                    </p>
                                    <p>
                                        <span v-bind:class="[{ catalogue: result.type === 'Catalogue' }, { inventory: result.type === 'Inventory' }, 'label']">{{result.type}}</span>
                                        <span class="label search-store" v-show="result.search_label">{{result.search_label}}</span>
                                        <span class="label search-store" v-show="result.store_city">{{result.store_city}}</span> 
                                        <span class="label search-price" v-show="result.price">${{parseFloat(result.price).toLocaleString('en-US')}}</span>
                                    </p>
                                    <p class="description nowrap overflow-ellipses">
                                        <ais-snippet :result="result" attribute-name="description"></ais-snippet>
                                    </p>
                                </div>
                                <div style="clear: both"></div>
                            </a>
                        </div>
                    </template>
                </ais-results>
                <ais-pagination class="pagination" v-on:page-change="onPageChange"></ais-pagination>
            </div>


        </ais-index>
    </div>
</template>

<script>
    import {createFromAlgoliaCredentials} from 'vue-instantsearch';

    const searchStore = createFromAlgoliaCredentials(window.algolia.app_id, window.algolia.search_key);
    export default {
        data() {
            return {
                searchStore,
                params: {
                    filters: '(regions:' + window.appVars.region + ')'
                },
                baseUrl: window.appVars.url,
                query: window.algolia.query,
                indexName: window.algolia.index_name,
            };
        },
        methods: {
            onPageChange(page) {
                $("html, body").animate({ scrollTop: $('.results').position().top });
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SearchResults.vue